"use strict";

import $ from 'jquery';
import appInit from './src/script-article';

window.$=window.jQuery=$;

window.app=null;

$(function () {
    window.app=new appInit();
});